import { JitsiConference, JitsiMeet } from "lib/lib-jitsi-meet";
import { ChatUIState } from "../../common";
import AbstractDataComponent from "./AbstractDataComponent";

export interface PublicMessageManagerProps {
    jitsi: JitsiMeet;
    room: JitsiConference;
    uiState: ChatUIState;
}

export default class extends AbstractDataComponent<PublicMessageManagerProps> {
    public componentDidMount() {
        const { jitsi, room } = this.props;
        room.on(jitsi.events.conference.MESSAGE_RECEIVED, this.handleMessageReceived);
    }

    public componentWillUnmount() {
        const { jitsi, room } = this.props;
        room.off(jitsi.events.conference.MESSAGE_RECEIVED, this.handleMessageReceived);
    }

    private handleMessageReceived = (userId: string, message: string, ts: number, userNickname: string) => {
        const { room, uiState } = this.props;
        const { isMessageInFlight } = uiState;
        const isSelf = userId === room.myUserId();
        const timestamp = ts == null ? new Date() : new Date(ts);
        const newMessage = {
            userId,
            message,
            timestamp,
            userNickname,
            isSelf,
        };

        if (isMessageInFlight && isSelf) {
            // clear input
            uiState.isMessageInFlight = false;
            uiState.inputValue = "";
        }
        uiState.messages.push(newMessage);
    };
}
